@if (currentlyEditedByAnotherUser()) {
  <div class="tt-currently-edited-by_label">{{ 'GuidelineEditor.Concurrency.CurrentlyEditedBy' | transloco }}:</div>
  <div class="tt-currently-edited-by_avatars stacked">
    @for (user of currentlyEditingUsers(); track user.id) {
      <tt-avatar
        class="stacked-avatar"
        data-testid="user-info_button-settings"
        [placeholder]="user | initials"
        [ttTooltip]="user | name" />
    }
  </div>
} @else if (refreshGuidelineButtonEnabled()) {
  <button ttButton
    [ttTooltip]="'GuidelineEditor.Concurrency.ReloadGuidelineButtonTooltip' | transloco"
    [variant]="'outline'"
    (click)="reload.emit()">
    <mat-icon [icon]="'refresh-cw'" [iconSize]="16" />
    {{ 'GuidelineEditor.Concurrency.ReloadGuidelineButton' | transloco }}
  </button>
}
